__turbopack_context__.v({
  "listItem": "styles-module-scss-module__ncRLiW__listItem",
});
